import axios from 'axios';
import React, { useEffect, useState } from 'react'

const MerchantHistory = () => {
  const [imgData, setImgData] = useState(null);
    
  
  return (
    <div className='container '>
      
      <img src='/images/category.jpg' className='img-fluid'/>
      
    </div>
  )
}

export default MerchantHistory